import { Component, OnInit, ViewChild } from '@angular/core';

import { MatTableDataSource } from '@angular/material';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { ToastrService } from 'ngx-toastr'
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { DatePipe } from '@angular/common';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DashboarduiService } from '../Shared/Service/dashboardui.service';
import beautify from 'xml-beautifier';

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export class idsProductList {
  id: number;
  status: String;
  hotelName: String;
  accountingDate: any;
  pusheddate: any;
  type: any
}
@Component({
  selector: 'app-guestprofile-log',
  templateUrl: './guestprofile-log.component.html',
  styleUrls: ['./guestprofile-log.component.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})
export class GuestprofileLogComponent implements OnInit {
  storeUserID: any
  apiresult: any;
  statusResult: string;
  requestPayload: any;
  storeOptionData = "FN";
  errorMsgSubscription: boolean;
  displayContent: boolean;
  errorMessage: string;
  public idsProductList: idsProductList[];
  dataSource: MatTableDataSource<idsProductList>;
  // dataSource: any = [];
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  status: void;
  XMLName: any;
  defaultData: any;
  display: boolean;
  constructor(private apiCallIdsService: DashboarduiService, private toastr: ToastrService, private datePipe: DatePipe) {

  }

  selected: string;
  selectedItems: any;
  Source: string;
  Userid: any = [];
  public User: string;
  rateCode: string;
  property: string;
  SourceBy: string;
  today = new Date();
  today1: any = new Date();
  selectedDate: any = new Date(this.today.setDate(this.today.getDate() - 1));
  selectedTOODate: any = new Date(this.today1.setDate(this.today1.getDate() - 1));
Val:any
  isProgressing: Boolean = false;
  Pmscodevalue: any;
  filterProperty: any;
  displayedColumns = ['Status','Hotel','pmsresult','createdatetime','lastUpdatedatetime','Profile'];
  displayedColumnsChannelLogs = ['Status','Hotel','createdatetime','lastUpdatedatetime','Profile','Request','Response'];
  dropdownSettingsDept: IDropdownSettings = {};
  selectedDeptItems:any;
  dropdownDeptData: any
  totalcount: any = 0;
  pageSize = 50;
  searchBarFilter: boolean = false;

  hideSearchFilter(){
    this.Val = '';
    this.searchBarFilter = false
  }
  ngOnInit() {
    this.errorMsgSubscription = true
    this.errorMessage = "Please select property and load"
    this.displayContent = false
    this.callIDSUsersProperties();
    this.SourceBy = "FN";
    this.statusResult = "Not Sent"   
    this.dropdownSettingsDept = {
      idField: 'propertyCode',
      textField: 'propertyName',
      allowSearchFilter: true,
      singleSelection: true,
      enableCheckAll: false,
      closeDropDownOnSelection: true,
      itemsShowLimit: 7,
      noDataAvailablePlaceholderText: 'No Data Found',
      searchPlaceholderText: "Search Hotel Code / Name"
    };
  }

  callIDSUsersProperties() {
    this.storeUserID = localStorage.getItem("Username");
    console.log('this.storeUserID', this.storeUserID)
    this.apiCallIdsService.getGuestProfiePropList()
      .subscribe(
        data => {
          // console.log('New Screen Data', data)
          this.apiresult = data;
          console.log('this.SourceBy =', this.SourceBy)
          this.dropdownDeptData = this.apiresult
            this.apiresult.unshift({
              "propertyCode": "All",
              "propertyName": "All Property"
            });
            this.selectedDeptItems = this.getDimensionsByFilter("All");
        console.log('this.StoreValuetest',this.selectedDeptItems[0].propertyCode);
        this.Pmscodevalue = this.selectedDeptItems[0].propertyCode
        console.log('this.Pmscodevalue =',this.Pmscodevalue)
          this.isProgressing = false;
        });
  }

  getDimensionsByFilter(propertyCode:any){
    console.log('dropdownDeptData =',this.dropdownDeptData)
    return this.dropdownDeptData.filter((x: { propertyCode: any; }) => x.propertyCode === propertyCode);
  }

  changePropertySearch() {
    // console.log('selectedDeptItems = ',this.selectedDeptItems)
    if (this.selectedDeptItems) {
      this.searchBarFilter = false
    this.Val = '';
      if (this.selectedDeptItems.length > 0) {
        console.log('if condition')
        this.totalcount = 0;
        console.log('selectedDeptItems = ', this.selectedDeptItems)
        this.errorMsgSubscription = true
        this.errorMessage = "Please select property and load"
        this.displayContent = false
        this.Pmscodevalue = this.selectedDeptItems[0].propertyCode
        console.log('pms code value = ', this.Pmscodevalue)

      } else {
        console.log('Else condition zero')
        this.errorMsgSubscription = true
        this.errorMessage = "Please select property and load"
        this.displayContent = false
      }
    } else {
      console.log('Property Not Selected')
    }
  }

  changeOption(data: any) {
    console.log("changeOption Value--->" + data);
    this.storeOptionData = data
    if (data == 'Channel') {
      this.statusResult = "Not Sent"
      this.SourceBy = data
      this.totalcount = 0
      this.errorMsgSubscription = true
      this.errorMessage = "Please click load"
      this.displayContent = false
      // this.selectedDeptItems = ""
      this.callIDSUsersProperties();
    } else {
      this.statusResult = "Not Sent"
      this.SourceBy = data
      this.totalcount = 0
      this.errorMsgSubscription = true
      this.errorMessage = "Please click load"
      this.displayContent = false
      // this.selectedDeptItems = ""
      this.callIDSUsersProperties();
    }
  }

    loadGuestProfile() {
    this.searchBarFilter = true
    this.isProgressing = true;
    this.selectedDate = this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd');
    this.selectedTOODate = this.datePipe.transform(this.selectedTOODate, 'yyyy-MM-dd');
    if(this.selectedTOODate < this.selectedDate ){
    this.isProgressing = false;
    this.toastr.error('From date shuold be less than To date.');
    }else{
      this.requestPayload = {
        "PMSCODE": this.Pmscodevalue,
        "FRMDATE": this.selectedDate,
        "TOODATE": this.selectedTOODate,
        "STATUS": this.statusResult,
      }
      console.log('Request =', this.requestPayload)
      if(this.SourceBy == 'FN'){
        console.log('SourceBy If= "FN"')
        this.apiCallIdsService.readGuestProfieLogAPI(this.requestPayload)
          .subscribe(
            data => {
              console.log('Data =', data)
              this.idsProductList = data;
              this.filterProperty = this.idsProductList
              this.dataSource = new MatTableDataSource(this.idsProductList);
              this.dataSource.paginator = this.paginator;
                if (data.length > 0) {
                  console.log('FN Data = ', data);
                  this.errorMsgSubscription = false
                  this.displayContent = true
                  this.totalcount = data.length
                  this.toastr.success('Data loaded Successfully');
                  this.isProgressing = false;
                } else {
                  this.displayContent = false
                  this.errorMsgSubscription = true
                  this.errorMessage = "No Data Found"
                  this.toastr.error('No Data Found');
                  this.isProgressing = false;
                }
            });
      }
      else{
        console.log('SourceBy Else = "Channel"')
        this.apiCallIdsService.readGuestProfieChannelLogAPI(this.requestPayload)
        .subscribe(
          data => {
            console.log('Data =', data)
            this.idsProductList = data;
            this.filterProperty = this.idsProductList
            this.dataSource = new MatTableDataSource(this.idsProductList);
            this.dataSource.paginator = this.paginator;
              if (data.length > 0) {
                console.log('Log Data = ', data);
                this.errorMsgSubscription = false
                this.displayContent = true
                this.totalcount = data.length
                this.toastr.success('Data loaded Successfully');
                this.isProgressing = false;
              } else {
                this.displayContent = false
                this.errorMsgSubscription = true
                this.errorMessage = "No Data Found"
                this.toastr.error('No Data Found');
                this.isProgressing = false;
              }
          });
      }
  
      
    }
    
  }

  showXml(token: any, xmltype: any) {
    this.status = this.LoadXML(token, xmltype);
}
LoadXML(token: any,xmltype: any) {
  this.isProgressing = true;
  console.log('token',token);
  console.log('xmltype',xmltype);
  if(this.SourceBy == 'FN'){
    console.log('LoadXML FN');
    this.apiCallIdsService.GuestProfieLogJSON(token, xmltype)
    .subscribe(data => {
      console.log('Data JSON =', data[0])
      if (data.length < 1) {
        this.toastr.error('No data to load');
        this.isProgressing = false;
      }else{
        const xml = beautify(data[0].jsonData);
        console.log(xml);
        this.XMLName = xmltype
        this.defaultData = xml;
        this.display = true;
        this.isProgressing = false;
      }
     
    },
      error => {
        this.toastr.error("Falied to load requests !");
        this.isProgressing = false;
      },

    );
  }
  else{
    console.log('LoadXML Channel');
    this.apiCallIdsService.GuestProfieChannelLogJSON(token, xmltype)
    .subscribe(data => {
      console.log('Data JSON =', data[0])
      if (data.length < 1) {
        this.toastr.error('No data to load');
        this.isProgressing = false;
      }else{
        const xml = beautify(data[0].jsonData);
        console.log(xml);
        this.XMLName = xmltype
        this.defaultData = xml;
        this.display = true;
        this.isProgressing = false;
      }
     
    },
      error => {
        this.toastr.error("Falied to load requests !");
        this.isProgressing = false;
      },

    );
  }
 
}

closeModalDialog() {
  this.display = false;
}

Search(event: any) {
  console.log('event= ', event)
  this.dataSource = this.filterProperty.filter((res: { propertyCode: { toString: () => string; }; propertyName: { toString: () => string; }}) => {
    return res.propertyCode.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase()) || res.propertyName.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase())
  });
  if (event == '') {
    this.Val = '';
    this.totalcount = 0
      this.loadGuestProfile()
  }
}

pageEvent(e: any) {
  console.log('pageEvent = ', e)
  var pageIndex = e.pageIndex;
  pageIndex = pageIndex;
  console.log('pageIndex = ', pageIndex)
  this.pageSize = e.pageSize
  console.log('pageSize = ', this.pageSize)
  this.loadGuestProfile();
}


  FOOTFALL() {
    this.User = localStorage.getItem("Username");
    this.apiCallIdsService.getfootfall(this.User, 'BTEA', 'btea upload')
      .subscribe(
        data => {
        });
  }
}
